import SiChevronDown from '@/icons/SiChevronDown';
import SiInformation from '@/icons/SiInformation';
import { FC, ReactNode } from 'react';
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuGroup,
  DropdownMenuItem,
  DropdownMenuTrigger
} from '../../dropdown/Dropdown';
import { InputContainer } from '../InputContainer';
import { InputProps, withField } from '../withField';

export type IconConfiguration = Record<string, ReactNode>;

interface TextAndIconInputProps {
  placeholder?: string;
  placeholderIcon?: ReactNode;
  icons: IconConfiguration;
}

export interface TextAndIconValue {
  text?: string;
  iconId?: string;
}

export const TextAndIconInput: FC<InputProps<TextAndIconValue> & TextAndIconInputProps> = ({
  onChange,
  value,
  id,
  icons,
  placeholder,
  placeholderIcon = <SiInformation />,
  autofocus
}) => {
  const text = value?.text;
  const iconId = value?.iconId;
  return (
    <InputContainer className="items-stretch">
      <DropdownMenu>
        <DropdownMenuTrigger asChild>
          <div className="hover:bg-primary-std flex cursor-pointer items-center justify-center rounded-l-lg border border-r-0 border-gray-200 px-2 text-2xl">
            {value?.iconId ? icons[value.iconId] : <span className="opacity-60">{placeholderIcon}</span>}
            <SiChevronDown />
          </div>
        </DropdownMenuTrigger>
        <DropdownMenuContent>
          <DropdownMenuGroup className="grid grid-cols-3 gap-2 max-h-64 overflow-y-auto p-2">
            {Object.entries(icons).map(([id, icon]) => (
              <DropdownMenuItem
                key={id}
                className="text-secondary-std flex items-center justify-center p-1 text-2xl cursor-pointer"
                onClick={() => onChange({ text, iconId: id })}
              >
                <span>{icon}</span>
              </DropdownMenuItem>
            ))}
          </DropdownMenuGroup>
        </DropdownMenuContent>
      </DropdownMenu>
      <InputContainer className="rounded-l-none shadow-none">
        <input
          autoFocus={autofocus}
          value={text}
          onChange={e => onChange({ text: e.target.value, iconId })}
          type="text"
          id={id}
          className="placeholder:text-secondary-std block flex-1 border-0 bg-transparent px-3 py-2 text-sm focus:ring-0 sm:leading-6"
          placeholder={placeholder}
        />
      </InputContainer>
    </InputContainer>
  );
};

export const TextAndIconField = withField<TextAndIconValue, TextAndIconInputProps>(TextAndIconInput);
